/**
 * Web adapter for react-native-video.
 *
 * The Vite web build aliases `react-native-video` to this file so that
 * `import Video from 'react-native-video'` resolves to a no-op component
 * in the web build. Video playback is a native-only feature; the web build
 * is used for development/preview only.
 */
import React from 'react';

export const Video = React.forwardRef<HTMLVideoElement, Record<string, unknown>>((props, _ref) => {
    // Render a basic HTML5 video element for the web build
    const { source, style, controls, paused, poster, onError, ...rest } = props as any;
    return React.createElement('video', {
        src: source?.uri,
        style,
        controls: controls !== false,
        poster,
        onError,
        ...rest,
    });
});

export default Video;
